import Component from "../abstracts/Component";

export default class SortByComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-sortby]',
      input: '.js-sortby-input',
      placeholderValue: '.js-sortby-value'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {
    this.$on('change.sortBy', ({event}) => {
      let input = event.currentTarget;
      let main = document.querySelector(this.SELECTORS.main);
      let valuePlaceholder = document.querySelector(this.SELECTORS.placeholderValue);

      main.dataset.sortby = input.value;
      valuePlaceholder.innerText = input.dataset.sortbyName;

      this.$emit(this.$customEvents.SORT_BY_EVENTS.changed, {
        value: input.value,
        name: input.dataset.sortbyName,
      });
    }, this.SELECTORS.input);
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) {
      this.bindEvents();
    }
  }
}
